import User from '@/utils/user.js';

import MemberModel from './member';
import BaseModel from './base';

import teamService from '@/services/API/team/index';
import { fetchUser } from './user';

import { rHandler } from '@/plugins/RHandler';

import { EVENT_TEAM_STATUS, EVENT_TEAM_STATUS_DATA } from '@/modules/Events/constants';

export default class Team extends BaseModel {
  constructor(team, url) {
    super(team, url);

    this.description = team.description || null;

    this.owner_id = team.owner_id || null;
    this.captain_id = team.captain_id || null;

    this.created_at = team.created_at || null;

    this.avatar = team.avatar || null;
    this.members = [];
    this.setMembersModel(team.members || []);

    this.members_count = team.members_count || this.members.length;

    this.status = EVENT_TEAM_STATUS_DATA[team.status || EVENT_TEAM_STATUS.STATUS_REQUEST];

    this.user = new User();
  }

  get isOwner() {
    return this.user?.data?.id === this.owner_id;
  }

  get membersCount() {
    return this.members.length;
  }

  setMembersModel(members, Model = MemberModel) {
    this.members = (members || []).map((member) => new Model(member));
  }

  // !!! NOTE (#trainer): Обсудить возможность получать все данные юзера сразу (чтоб этим костылём не пользоваться)
  fetchMembersProfiles() {
    if (!this.members?.length) return null;
    return fetchUser(this.members.map((i) => i.id)).then(({ response, error }) => {
      if (!error) {
        const users = (response?.data?.data || []);
        this.members.forEach((member) => {
          const { profile, directory_attributes, certificate } = users.find((item) => item.id === member.id) || {};
          member.directory_attributes = directory_attributes;
          member.certificate = certificate || member.certificate;
          member.setProfile(profile || member.profile);
        });
      }
      return { items: this.members, response, error };
    });
  }

  async setCaptain(params) {
    const answer = await rHandler(
      teamService.setCaptain(this.id, params),
      (response) => ({ response }),
      (error) => ({ error }),
    );
    if (!answer.error) {
      const { captain_id } = params;
      this.captain_id = captain_id;
    }
    return { ...answer };
  }

  async unsetCaptain() {
    const answer = await rHandler(
      teamService.unsetCaptain(this.id),
      (response) => ({ response }),
      (error) => ({ error }),
    );
    if (!answer.error) {
      this.captain_id = null;
    }
    return { ...answer };
  }
}
